import { updateBuffsAndGold } from './buffGoldPhase.js';
import { updateMinionSpawners } from './minionSpawnPhase.js';
import { updateChampionEntities } from './championEntityPhase.js';
import { updateActiveMinions } from './minionAiPhase.js';
import { updateChampionAttacks } from './championAttackPhase.js';
import { updateTickProjectiles } from './projectileTickPhase.js';
import { updateTurretAttacks } from './turretAttackPhase.js';
import { updatePersistentAbilityZones } from './persistentAbilityZonePhase.js';

/** Named simulation phases for GameOrchestrator.tick (+ soft perf ids). */
export const TICK_PHASES = [
  { id: 'buffGold', fn: updateBuffsAndGold },
  { id: 'minionSpawn', fn: updateMinionSpawners },
  { id: 'championEntities', fn: updateChampionEntities },
  { id: 'minionAi', fn: updateActiveMinions },
  { id: 'championAttacks', fn: updateChampionAttacks },
  { id: 'projectiles', fn: updateTickProjectiles },
  { id: 'turretAttacks', fn: updateTurretAttacks },
  { id: 'persistentZones', fn: updatePersistentAbilityZones }
];

/** Simulation order for GameOrchestrator.tick (objectives/vision stay as existing systems). */
export const TICK_PHASE_ORDER = TICK_PHASES.map((p) => p.fn);

export {
  updateBuffsAndGold,
  updateMinionSpawners,
  updateChampionEntities,
  updateActiveMinions,
  updateChampionAttacks,
  updateTickProjectiles,
  updateTurretAttacks,
  updatePersistentAbilityZones
};
